import {Action, ActionType} from 'app/pages/AgentPricing/actionTypes';
import { SaveState } from 'app/shared/ui/GenericSaveAndBackButton';
import { AgentCommissionStatus } from 'app/shared/model/AgentCommissionDto';
let ChangeNumber = 0;

type State = {
    CurrentChangeNumber: number
    SavedChangeNumber: number,
    NumberBeingSaved: number,
    isSaving: boolean,
    hasError: boolean,
    validationMessage: string | null
}

const defaultState: State = {
    CurrentChangeNumber: 0,
    SavedChangeNumber: 0,
    NumberBeingSaved: 0,

    isSaving: false,
    hasError: false,
    validationMessage: null
}

function getRoot(state: any) {
    return state.saveStatus as State;
}

export function getSaveStatus(state: any) : SaveState {
    const root = getRoot(state);
    if (root.isSaving)
        return SaveState.Saving;
    if (root.CurrentChangeNumber > root.SavedChangeNumber)
        return SaveState.Standard;
    if (root.CurrentChangeNumber === 0)
        return SaveState.NoChanges;

    return SaveState.Saved;
}

export function getCurrentChangeNumber(state: any) {
    const root = getRoot(state);
    return root.CurrentChangeNumber;
}

export function getHasSaveError(state: any) {
    const root = getRoot(state);
    return root.hasError;
}

export function getValidationMessage(state: any): string | null {
    return getRoot(state).validationMessage;
}

export function reducer(state: State|undefined, action: Action): State {
    if (!state)
        state = defaultState;

    switch(action.type) {
        case ActionType.EditPageLoaded:
            if (action.agentCommission.status == AgentCommissionStatus.New) {
                return {
                    ... state,
                    SavedChangeNumber: 0,
                    NumberBeingSaved: 0,
                    CurrentChangeNumber: 1,
                    validationMessage: null,
                    hasError: false
                };
            }

            return {
                ...state,
                validationMessage: null,
                hasError: false
            };
        case ActionType.ChangeRate:
        case ActionType.ChangeSchoolOverrides:
        case ActionType.ChangeStartDate:
        case ActionType.ChangeEndDate: {
            const cleared = {
                ...state,
                validationMessage: null,
                hasError: false
            };
            if (cleared.CurrentChangeNumber > cleared.SavedChangeNumber)
                return cleared;
            return {
                ...cleared,
                CurrentChangeNumber: ++ChangeNumber
            };
        }

        case ActionType.StartSavingRates:
            if (action.changeNumber < state.NumberBeingSaved)
                return state;
            return {
                ... state,
                isSaving: true,
                NumberBeingSaved: action.changeNumber,
                validationMessage: null,
                hasError: false
            }

        case ActionType.SaveRatesSuccessful:
            if (state.NumberBeingSaved > action.changeNumber)
                return state;
            return {
                ... state,
                isSaving: false,
                SavedChangeNumber: action.changeNumber,
                hasError: false,
                validationMessage: null
            }

        case ActionType.ErrorSavingRates:
            if (state.NumberBeingSaved > action.changeNumber)
                return state;

            return {
                ... state,
                NumberBeingSaved: 0,
                hasError: true,
                isSaving: false,
                validationMessage: null
            }

        case ActionType.RatesValidationError:
            return {
                ...state,
                isSaving: false,
                hasError: false,
                validationMessage: action.message
            }

        default:
            return state;
    }
}